<template>
  <div id="container" class="flex_one">
    <div class="list_box full_layout">
      <div class="list_left_box">
        <div class="tac">
          <el-collapse v-model="activeNames" class="seach_list_left">
            <el-collapse-item :name="i" v-if="newChild.length>0" v-for="(res,i) in newChild" :key="i">
              <template slot="title">
                <span class="collapseSpan">{{res.Title}}</span>
              </template>
              <div class="choose_list" :class="(!newSearchJson.commoditySeries&&newSearchJson.commodityType==res.Title)?'active':''" @click="setSecondData(newChild,i,'')">
                {{$t('base.all')}}
              </div>
              <div class="choose_list" :class="newSearchJson.commoditySeries==item.Title?'active':''" v-for="(item,j) in res.Childs" :key="j" @click="setSecondData(newChild,i,item.Title)">
                {{item.Title}}
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="activeNames" class="seach_list_left">
            <el-collapse-item :name="1">
              <template slot="title">
                <span class="collapseSpan">{{$t('base.size')}}</span>
              </template>
              <div class="choose_list" :class="!newSearchJson.commodityYear?'active':''" @click="setTrdData('')">
                {{$t('base.all')}}
              </div>
              <div class="choose_list" :class="newSearchJson.commodityYear==item.Title?'active':''" v-for="(item,g) in trdChild" :key="g" @click="setTrdData(item.Title)">
                {{item.Title}}
              </div>
            </el-collapse-item>
          </el-collapse>

        </div>
      </div>
      <div class="list_right_top">
        <div class="Manufacturer">
          <div :class="newSearchJson.manufacturer==item.Title?'on':''" @click="setFirstData(item.Title,index)" v-for='(item,index) in SearchCategory' :key='index'>
            <img :src="newSearchJson.manufacturer==item.Title?item.ImgSelectedUrl:item.ImgUrl">
          </div>
        </div>
        <div class="list_right_box">
          <!-- border_top -->
          <div class="border_top all_item">
            <div class="seller_tab">
              <div class="sort_price" :class="isSort == 3 ? 'activesort' : ''" @click="GoodSort(3)">{{$t('base.newly')}}</div>
              <div class="sort_price sort_price1" :class="isSort == 2 ? 'activesort' : ''" @click="GoodSort(2)">
                {{$t('base.price')}}
                <em class="up_arr" :class="isPrice ? 'up' : ''"></em>
                <em class="up_down" :class="!isPrice && isPrice != null ? 'up' : ''"></em>
              </div>
            </div>
            <!-- <div class="">
              <div class="trdBox">
                <span :class="!newSearchJson.commodityYear?'on':''" @click="setTrdData('')">{{$t('base.all')}}</span>
                <span :class="newSearchJson.commodityYear==item.Title?'on':''" v-for="(item,index) in trdChild" :key="index" @click="setTrdData(item.Title)">{{item.Title}}</span>
              </div>
            </div> -->
            <div class="goodSum">
              {{TotalCount}} {{TotalCount!=1?'Items':'Item'}}
            </div>
          </div>
          <el-skeleton :count="12" animated class="thousand_layout skull" :loading="loading">
            <template slot="template">
              <list-skeleton />
            </template>
            <template>
              <goods-list class="thousand_layout" :list="list" type="card" />
            </template>
          </el-skeleton>
          <list-pagination class="full_layout" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!ifData" />
          <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
          <!-- <f-z-f class="notfind" title="" text="Pagefault" v-else /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//官方商城
import { getInfo, resetCategory, getCategory, GetyCategories, CookiesCategory, resetStoreCategory } from "@/api/public";
import GoodsList from "@/components/list/storegoods";
import ListPagination from '@/components/listpagination'
import NOTN from "@/components/notnull.vue";
import FZF from "@/components/404.vue";
import ListSkeleton from "@/components/skeleton.vue";

export default {
  name: "index",
  components: { GoodsList, ListPagination, NOTN, FZF, ListSkeleton },
  data() {
    return {
      userInfo: '',
      searchKey: null,
      sort: '',
      sortType: '',
      activeNames: [0, 1, 2], // el-collapse展开——默认展开
      loading: false,
      CategoryKeys: [],
      ifData: false,
      list: {},
      all_Sort: this.$enumInfo.searchSort,
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
      isPrice: '',
      isSort: 3, //筛选
      SearchCategory: [], //新类目列表
      newChild: [], //新类目二级类目
      trdChild: [], //新类目三级类目
      newSearchJson: {
        manufacturer: '', //厂商
        commodityType: '', //类型
        commodityYear: '', //年代
        commoditySeries: '', //系列？箱盒
      },
    };
  },
  watch: {
    'userInfo': {
      handler(val) {
        //this.getDetailList()
      }
    }
  },
  created() {
    let that = this;
    this.userInfo = getInfo();
    // this.getCategoryList();
    // this.getThirdCategoryId();
    // this.getType()
    this.getNewCategory()
    // this.GoodSort(3)
  },
  mounted() {
    //this.getCategoryList();
  },
  beforeRouteUpdate(to, from, next) {
    let that = this;
    this.userInfo = getInfo();
    this.getNewCategory()
    next()
  },
  methods: {
    // 获取类目（新）
    /**
     * 获取并设置分类数据
     * 从接口获取分类缓存数据，根据用户区域码筛选
     * 重置分类数据结构并设置一级分类数据
     * @returns {void}
     */
    getNewCategory() {
      let that = this
      this.Loading(true)
      let data = { AreaCode: 'US' }
      if (that.userInfo != null) {
        data.AreaCode = that.userInfo.MemberSource
      }
      this.$get(this.$interface.GetCategoryCache, data).then(res => {
        if (res.Result) {
          
          try{
              let NewCategory=resetStoreCategory(res.Data, ['FristList', 'SecondList', 'ThirdList'])
              
              that.SearchCategory = NewCategory.filter(item=> item.ManufacturerType==0)
            }catch(e){
              console.log(e)
            }
        
        
        // if(that.SearchCategory){
        //     let result=''
        //     result=that.SearchCategory.filter((item)=>
        //       item.manufacturer!=1
        //     )
        //     that.SearchCategory=result
        //     //console.log(result,'result')
        //   }
        }
        var id = this.$route.query.type || that.SearchCategory[0].Title // 获取一级ID,
        var index = this.$route.query.index || 0 // 获取 数组下标
        that.setFirstData(id, index)

        //console.log(type,index)

        //this.Manu(this.$route.query.type, parseInt(this.$route.query.index))
      })
    },
    Loading(val) {
      this.loading = val
    },
    //SearchCommodity 根据条件获取列表数据
    /**
     * 获取详细列表数据
     * @param {any} val - 参数值
     * @description 根据筛选条件获取分页列表数据,包含地区码、页码、每页数量、标题等参数
     * @description 发送请求到后端接口并更新列表数据状态
     * @returns {Promise} 返回请求Promise对象
     */
    getDetailList(val) {
      this.Loading(true)
      let that = this;
      let title = window.localStorage.getItem('sn') != null ? window.localStorage.getItem('sn') : '';
      let data = { AreaCode: 'US', pageIndex: that.pi, pageSize: that.ps, title: title,sort:that.sort,sortType:that.sortType,manufacturerType:0 }
      data = Object.assign(data, that.newSearchJson)
      if (that.userInfo != null) {
        data.AreaCode = that.userInfo.MemberSource
      }
      //console.log(data, 'url')
      //let newSearchJson = JSON.stringify(that.newSearchJson);

      this.$post(this.$interface.GetListByPage, data).then(res => {
        if (res.Result != 0) {
          var data = res.Data;
          that.TotalCount = parseInt(res.Count)
          that.list = data;
          that.goodSum = parseInt(res.Count)
          if (data.length <= 0) {
            this.ifData = true;
          } else {
            this.ifData = false;
          }
        } else {
          this.ifData = true;
        }
        that.resultTpye = res.Result

        that.Loading(false)
      })
    },
    // 获取一级类目
    /**
     * 设置商品列表的初始筛选数据
     * @param {string} id - 厂商ID
     * @param {number} index - 索引值
     * @description 根据选择的厂商ID设置商品类型、系列、年代等筛选条件，
     * 同时处理URL查询参数中的排序和筛选条件，最后获取商品列表数据
     */
    setFirstData(id, index) {
      let that = this
      that.newChild = []
      that.newSearchJson = {
        manufacturer: '', //厂商
        commodityType: '', //类型
        commodityYear: '', //年代
        commoditySeries: '', //系列？箱盒
      }
      that.SearchCategory.map((item, index) => {
        if (item.Title == id) {
          that.newChild = item.Childs
          that.newSearchJson.manufacturer = id
          if(that.newChild.length>0){
            that.newSearchJson.commodityType = that.newChild[0].Title
            that.trdChild = that.newChild[0].Childs2
          }
        }
      })
      if(that.$route.query.s){
        that.newSearchJson.commodityType = that.$route.query.s
      }
      if(that.$route.query.t){
        that.newSearchJson.commoditySeries = that.$route.query.t
      }
      if(that.$route.query.size){
        that.newSearchJson.commodityYear = that.$route.query.size
      }
      if(that.$route.query.Sort){
        that.sort = that.$route.query.Sort
        if(that.$route.query.Sort=='LowestPrice'){
          that.isSort=2 
        }
      }
      if(that.$route.query.SortType){
        that.sortType = that.$route.query.SortType
        if(that.$route.query.Sort&&that.$route.query.Sort=='LowestPrice'){
          if(that.sortType=='asc'||that.sortType=='ASC'){
            that.isPrice=true
          }else if(that.sortType=='desc'||that.sortType=='DESC'){
            that.isPrice=false
          }
        }
      }

      that.getDetailList()
    },
    // 获取二级类目 obj:二级类目 ,index:val:三级系列title
    /**
     * 设置二级分类数据并更新搜索条件
     * @param {Array} obj - 包含分类数据的数组
     * @param {number} index - 当前选中的分类索引
     * @param {string} val - 选中的商品系列值
     * @description 根据选中的二级分类更新搜索条件，如果商品类型发生变化则重置相关字段，并触发列表数据刷新
     */
    setSecondData(obj, index, val) {
    //console.log(obj, index, val)
      let that = this
      var commodityType = obj[index].Title
      var oldType = that.newSearchJson.commodityType
      that.newSearchJson.commoditySeries = val
      if (oldType != commodityType) {
        that.newSearchJson.commodityType = commodityType
        that.trdChild = obj[index].Childs2
        that.newSearchJson.commodityYear = ""
      }
      that.getDetailList()
    },
    // 获取三级
    setTrdData(val) {
      let that = this
      that.newSearchJson.commodityYear = val
      that.getDetailList()
    },
    // 获取yearlist 
    setYearList(obj, type) {
      let that = this
      that.newSearchJson.YearID = obj._id
      that.getDetailList()
    },
    // 筛选——价格/最新上架
    /**
     * 处理商品排序逻辑
     * @param {number} val 排序类型
     * - 0: 清除排序
     * - 1: 默认排序
     * - 2: 价格排序(升序/降序切换)
     * - 3: 最新时间排序
     * @description 根据传入的排序类型设置相应的排序参数,并重新获取商品列表
     */
    GoodSort(val) {
      let that = this;
      this.isSort = val
      if (val == 0) {} {
        that.sort = '';
        that.sortType = '';
      }
      if (val == 1) {
        that.sort = that.all_Sort[0]['val'];
        that.sortType = that.all_Sort[0]['sortType'];
      }
      // 时间最新
      if (val == 3) {
        //that.sort = that.all_Sort[3]['val']
        //that.sortType = that.all_Sort[3]['sortType']

        that.sort = ''
        that.sortType = ''
      }
      //价格升降
      if (val == 2) {
        that.sort = that.all_Sort[1]['val'];
        that.isPrice = !that.isPrice;
        if (that.isPrice) {
          that.sortType = that.all_Sort[1]['sortType'];
        } else {
          that.sortType = that.all_Sort[2]['sortType'];
        }
      } else {
        that.isPrice = null;
      }
      this.getDetailList();
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getDetailList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getDetailList();
    },
  },
};

</script>
<style scoped>
@import "../../../static/css/search.css";

.full_layout {
  overflow: hidden;
}

.list_right_top {
  position: relative;
}

.list_right_box {
  padding-top: 10px;
}

.border_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.goodSum {
  display: inline-block;
  width: 155px;
  text-align: right;
}

 .list_right_box .all_item {
  border-bottom: none;margin: 0 0 16px;
    padding-top: 12px;
} 
/* .flex_layout_between {
  height: 100%;
  margin: 16px 0 12px;
  display: flex;
  align-items: center;
} */
.seller_tab {
  /* height: 36px; */
  display: flex;
}

.seller_tab .sort_price,.trdBox span {
  padding: 9px 12px;
  position: relative;
  border: 1px solid #e0e0e0;
}
.seller_tab .sort_price+.sort_price,.trdBox span+span{
  border-left: none;
}
.seller_tab .sort_price:first-child,.trdBox span:first-child{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.seller_tab .sort_price:last-child,.trdBox span:last-child{
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.seller_tab>div {
  cursor: pointer;
}

.sort_price .up {
  opacity: 1;
}

.el-divider--vertical {
  top: 17px;
}

.sort_price1 {
  padding-right: 22px !important;
}

/* .sort_price {
  height: 36px;
  line-height: 36px;
  padding: 9px 20px;
  border: 1px solid #e0e0e0;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  border-left: none;
  padding-right: 34px;
  position: relative;
} */
/* .sort_price:first-child {
  border-left: 1px solid #e0e0e0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  padding-right: 20px;
}
.sort_price:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
} */
.seller_tab .up_arr {
  position: absolute;
  top: 12px;
  right: 3px;
}

.seller_tab em {
  position: absolute;
  top: 18px;
  right: 3px;
}

.sort_price1 em {
  width: 12px;
  height: 7px;
  position: absolute;
  background: #f00;
  background: url(../../../static/images/icon/icon_down_arrow.png) 0 center no-repeat;
  background-size: 60%;
  opacity: 0.6;
}

.sort_price1 .up_arr {
  background-image: url(../../../static/images/icon/icon_up_arrow.png);
}

/deep/ .el-divider--vertical {
  top: 2px;
  margin-left: 15px;
}

.Manufacturer {
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: flex-start;
  z-index: 3;
  background-color: #fff;
  margin: 0 0 0 42px;
}

.Manufacturer>div {
  height: 56px;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 12px 0;
  cursor: pointer;
}
.Manufacturer>div+div{
  margin-left: 12px;
}

.Manufacturer>div img {
  height: 40px;
  width: 136px;
  object-fit: contain;
  border-radius: 4px;
}

/* .Manufacturer > div:nth-child(2n) img {
  height: 32px;
  width: 120px;
} */

.Manufacturer>div.on {
 /* background-color: #f0f0f0;*/
}
.trdBox {
  display: flex;
}
.trdBox span {
  cursor: pointer;
  position: relative;
}

.trdBox span.on {
  color: #5f6dae;
}

.trdBox span.on {
  font-weight: 700;
}

/deep/.seach_list_left .el-collapse-item__header:hover,
.collapseSpan,
.active,
 {
  color: #5f6dae !important;
}

.choose_list {
  padding: 0 16px;
  position: relative;
  cursor: pointer;
}

.choose_list.active {
  font-weight: 700;
  color: #5f6dae;
}

 .activesort,.trdBox span.on {
  background: #5f6dae;
  color: #fff;
} 

</style>



// WEBPACK FOOTER //
// src/pages/list/index.vue